import { post, get } from "./helper_api"
import * as url from "./helper_path"


const createProviderAPI = (params) =>  post(url.CREATE_PROVIDER, params).catch(err => err);

const getTypeDocumentsProviderAPI = (params) => get(url.GET_TYPE_DOCUMENTS_PROVIDER, params).catch(err => err);

const getPostalCodeAPI = (params) => post(url.GET_POSTAL_CODE, params).catch(err => err);

export {
  createProviderAPI, getTypeDocumentsProviderAPI, getPostalCodeAPI
}
